export const RevisionHistory = ({
  regulationDateString: enactmentDateString,
  revisionDateString,
}: {
  regulationDateString: string;
  revisionDateString?: string;
}) => {
  return (
    <div>
      <ul>
        <li>制定：{enactmentDateString}</li>
        {revisionDateString && <li>最終改定：{revisionDateString}</li>}
      </ul>
    </div>
  );
};
